/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type IssueTypeSettingsType from '@jira/spa-apps__project-settings-issue-type/src/IssueTypePage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyIssueTypeSettings: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof IssueTypeSettingsType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-settings-issue-type", jiraSpaEntry: "async-project-settings-issue-type" */ '@jira/spa-apps__project-settings-issue-type/src/IssueTypePage.tsx'
			),
		),
	);

type Props = RouteContext;

const AsyncIssueTypeSettings = ({ match }: Props): React.JSX.Element => {
	const { issueTypeId } = match.params;

	// unique pageId need to be set so that ApdexProvider would properly reset all the performance marks when switching between issue types
	const pageId = `project-settings-issue-types-${String(issueTypeId)}`;

	return <LazyPage Page={LazyIssueTypeSettings} pageId={pageId} shouldShowSpinner={false} />;
};

export default AsyncIssueTypeSettings;
